import { render, staticRenderFns } from "./SetGroupName.vue?vue&type=template&id=245f2a8c&scoped=true&"
import script from "./SetGroupName.vue?vue&type=script&lang=js&"
export * from "./SetGroupName.vue?vue&type=script&lang=js&"
import style0 from "./SetGroupName.vue?vue&type=style&index=0&id=245f2a8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245f2a8c",
  null
  
)

export default component.exports